<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-money-bill-transfer" />
            {{ $t('transactions') }}
        </template>

        <TransactionsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import TransactionsTable from '@src/partials/transactions/TransactionsTable.vue'
</script>
